import React, { useEffect, useState } from 'react';
import NotificationManager from './NotificationManager';
import Notifications from './Notifications';

const NotificationContainer = ({ enterTimeout = 400, leaveTimeout = 400}) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const handleStoreChange = (newNotifications) => {
      setNotifications([...newNotifications]);
    };

    NotificationManager.addChangeListener(handleStoreChange);

    return () => {
      NotificationManager.removeChangeListener(handleStoreChange);
    };
  }, []);

  const handleRequestHide = (notification) => {
    NotificationManager.remove(notification);
  };

  return (
    <Notifications
      enterTimeout={enterTimeout}
      leaveTimeout={leaveTimeout}
      notifications={notifications}
      onRequestHide={handleRequestHide}
    />
  );
};

export default NotificationContainer;